import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import QRCode from 'react-native-qrcode-svg';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { GlassCard } from '../GlassCard';

interface WifiQRCodeCardProps {
  qrCodeData: string;
}

export const WifiQRCodeCard: React.FC<WifiQRCodeCardProps> = ({ qrCodeData }) => {
  const { colors } = useThemeColors();

  return (
    <GlassCard style={styles.card}>
      <Text style={[styles.title, { color: colors.text.primary }]}>Quick Connect</Text>
      <View style={styles.qrContainer}>
        <QRCode value={qrCodeData} size={140} color="black" backgroundColor="white" />
      </View>
      <Text style={[styles.caption, { color: colors.text.muted }]}>
        Scan to connect automatically
      </Text>
    </GlassCard>
  );
};

const styles = StyleSheet.create({
  card: {
    alignItems: 'center',
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.sectionTitle,
    marginBottom: 16,
  },
  qrContainer: {
    backgroundColor: 'white',
    borderRadius: 8,
    padding: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  caption: {
    ...REDESIGN_TYPOGRAPHY.caption,
    textAlign: 'center',
    marginTop: 12,
  },
});
